export const EVENT_KEYS = {
  ADD_TOAST_TO_STACK: 'add_toast_to_stack',
  CLOSE_TOASTS_BY_TAG: 'close_toasts_by_tag',
}
